import $ from 'jquery';
import { isMobile } from 'shared/vidio_helpers';

export default class MuxLoader {
  static increaseMuxLimit() {
    $.ajax({
      url: '/mux-reporting',
      method: 'POST'
    });
  }

  static loadAndInit({ configs, player_init_time }) {
    if (configs && configs.enabled) {
      const { env_key } = configs;
      const options = this.options({ env_key, player_init_time });
      const script = this.createScript(options);
      this.appendToBody(script);
    }
  }

  static createScript(options) {
    const script = document.createElement('script');
    script.src = 'https://src.litix.io/videojs/4/videojs-mux.js';
    script.async = 'async';
    script.onload = () => {
      this.initMux(options);
    };
    return script;
  }

  static options({ env_key, player_init_time } = {}) {
    return {
      debug: false,
      data: {
        env_key: env_key,
        player_init_time: player_init_time,
        player_name: 'playbackjs',
        video_id: this.data().videoId(),
        video_title: this.data().videoTitle(),
        viewer_user_id: window.ahoy.visitorId,
        video_stream_type: this.videoStreamType(),
        page_type: this.pageType(),
        player_version: this.playerVersion(),
        video_encoding_variant: this.videoEncodingVariant(),
        video_duration: this.videoDuration(),
        view_session_id: this.data().playUUID(),
        sub_property_id: this.subPropertyId(),
        video_series: this.videoSeries(),
        video_content_type: this.videoContentType(),
        video_cdn: this.cdn()
      }
    };
  }

  static pageType() {
    return this.data().embed() == 'true' ? 'iframe' : 'watchpage';
  }

  static playerVersion() {
    try {
      return window.playback.Revision.tag;
    } catch (e) {
      return 'version undefined';
    }
  }

  static videoEncodingVariant() {
    if (this.data().vjsClipDashUrl() && !this.data().drmEnabled()) {
      return 'VP9';
    }
    return 'H264';
  }

  static videoDuration() {
    return this.data().isVideo() ? this.data().videoDuration() * 1000 : null;
  }

  static videoStreamType() {
    if (this.data().drmEnabled()) {
      return this.data().isVideo() ? 'on-demand-drm' : 'live-drm';
    } else {
      return this.data().isVideo() ? 'on-demand' : 'live';
    }
  }

  static subPropertyId() {
    return isMobile() ? 'web-mobile' : 'web-desktop';
  }

  static videoSeries() {
    return this.data().episodeNumber() > 0 ? this.data().filmTitle() : '';
  }

  static videoContentType() {
    if (this.data().isLivestreaming()) {
      if (this.data().preview()) {
        return 'preview-live';
      } else {
        return this.data().streamType() === 'TvStream' ? 'tv-stream' : 'event-stream';
      }
    } else {
      return this.data().preview() ? 'preview-vod' : 'vod';
    }
  }

  static initMux(options) {
    const mux_interval = window.setInterval(() => {
      if (window.player && window.player.isReady()) {
        window.clearInterval(mux_interval);
        this.getPlayerInstance().mux(options);
        this.bindErrorEvent();
        this.increaseMuxLimit();
      }
    }, 10);
  }

  static bindErrorEvent() {
    this.getPlayerInstance().on('error', this.onErrorCallback.bind(this));
  }

  static onErrorCallback() {
    this.getPlayerInstance().mux.emit('error', {
      player_error_code: this.getPlayerInstance().tech().errorCode(),
      player_error_message: this.getPlayerInstance().tech().errorMessage()
    });
  }

  static data() {
    return window.player.data();
  }

  static cdn() {
    return window.player.data().el().getAttribute('data-cdn')
  }

  static getPlayerInstance() {
    return window.player.tech().plugin().instance();
  }

  static appendToBody(element) {
    document.body.appendChild(element);
  }
}
